import { useEffect, useState } from "react";
import { fetchContentPage, findSection } from "../services/contentApi";

/**
 * Fetch a single section when no page provider is available.
 */
export function useCmsPageSection(slug, sectionKey, { skip = false } = {}) {
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(!skip);

  useEffect(() => {
    if (skip) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);

    fetchContentPage(slug)
      .then((page) => {
        if (!cancelled) setSection(findSection(page, sectionKey));
      })
      .catch((err) => {
        console.error(`Error fetching ${slug}/${sectionKey}:`, err);
        if (!cancelled) setSection(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [slug, sectionKey, skip]);

  return { section, loading };
}
